import {Injectable} from '@angular/core';
import {StatementM} from "../model/statement";
import {PaymentM} from "../model/payment";
import {Http, Headers, RequestOptions} from "@angular/http";
import {Util} from "../util/util";

@Injectable()
export class WalletService {
  private statement: StatementM = new StatementM();
  private payment: PaymentM = new PaymentM();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  withdraw(payment: PaymentM) {
    this.reloadToken()
    return this.http.post(`/api/order/add/`, payment, this.options).map(res => res.json());
  }

  getList(searchStr: string, status: string, offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/wallet/list?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getUserWithdrawList(searchStr: string, status: string, offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/wallet/withdraw/byUser?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getTransferList(searchStr: string, status: string, bank_id: number, startDate: string, endDate: string, offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/wallet/transfer?searchStr=${searchStr}&status=${status}&bank_id=${bank_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  updateStatementStatus(statement: StatementM) {
    this.reloadToken()
    return this.http.put(`/api/wallet/statement/updateStatus`, statement, this.options).map(res => res.json());
  }

  getStatusCount() {
    //this.reloadToken()
    return this.http.get(`/api/order/getStatusCount`, this.options).map(res => res.json());
  }

  createWithdraw(statement: StatementM) {

    this.reloadToken()
    return this.http.post(`/api/wallet/withdraw/`, statement, this.options).map(res => res.json());
  }

  getBankList() {
    this.reloadToken()
    return this.http.get(`/api/payment/banks`, this.options).map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/wallet.service.ts